import React, {useCallback, useEffect, useRef} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import {DocumentNotificationToast} from './DocumentNotificationToast';
import {useDocumentNotifications} from './DocumentNotificationsProvider';

const DOCUMENT_REQUEST_PATH = '/balance/document-request';

export const DocumentNotificationsToastGate: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const {
        notifications,
        notificationsKey,
        toastTitle,
        dismissedKey,
        dismissCurrentToast,
        markAllAsRead,
        refresh
    } = useDocumentNotifications();

    const autoReadKeyRef = useRef('');

    const isDocumentRequestPage = location.pathname.startsWith(DOCUMENT_REQUEST_PATH);

    useEffect(() => {
        if (!isDocumentRequestPage) {
            autoReadKeyRef.current = '';
            return;
        }

        if (!notificationsKey) {
            return;
        }

        if (autoReadKeyRef.current === notificationsKey) {
            return;
        }

        autoReadKeyRef.current = notificationsKey;

        void (async () => {
            await markAllAsRead();
            await refresh();
        })();
    }, [isDocumentRequestPage, notificationsKey, markAllAsRead, refresh]);

    const handleOpen = useCallback(() => {
        autoReadKeyRef.current = notificationsKey;
        navigate(DOCUMENT_REQUEST_PATH);

        void (async () => {
            await markAllAsRead();
            await refresh();
        })();
    }, [navigate, notificationsKey, markAllAsRead, refresh]);

    const shouldShowToast =
        !isDocumentRequestPage && notifications.length > 0 && dismissedKey !== notificationsKey;

    if (!shouldShowToast) {
        return null;
    }

    return (
        <DocumentNotificationToast
            title={toastTitle}
            description="Скачайте файлы в Запрошенных документах"
            onOpen={handleOpen}
            onClose={dismissCurrentToast}
        />
    );
};
